import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 14.883c0 .993-1.174 1.49-1.861.788l-2.82-2.883a1.133 1.133 0 0 1 0-1.576l2.82-2.883c.687-.703 1.861-.205 1.861.788z"
    }, null, -1)
  ])))
}
export default { render: render }